import dayjs from 'dayjs';
export function valueOrDefaultColumnRenderer(item) {
    return valueOrDefault(item, '--');
}
export function valueOrDefault(value, defaultValue) {
    if (value === undefined) {
        return defaultValue;
    }
    if (typeof value === 'object') {
        if (value === null) {
            return defaultValue;
        }
        if ((isCrmOptionSet(value) || isCrmLookup(value)) && value.DisplayValue) {
            return value.DisplayValue;
        }
        if (isCrmProcessStage(value) && value.StageName) {
            return value.StageName;
        }
        if (dayjs.isDayjs(value)) {
            return value.format('L');
        }
        return defaultValue;
    }
    if (value === '') {
        return defaultValue;
    }
    return String(value);
}
export function isCrmOptionSet(value) {
    return value.__typename === 'CRMOptionSetType';
}
export function isCrmLookup(value) {
    return value.__typename === 'CRMLookUpType';
}
export function isCrmProcessStage(value) {
    return value.__typename === 'ProcessStage';
}
//# sourceMappingURL=RenderUtils.js.map